import type { PlanApprovalStatus } from '../../../types';
import type { ToolInvocationEvent } from '../types';

type ResolveCompletedStatusParams = {
  isActive?: boolean;
  didAwaitApproval?: boolean;
  resultIsError?: boolean;
};

export const resolveCompletedStatus = ({
  isActive,
  didAwaitApproval,
  resultIsError,
}: ResolveCompletedStatusParams): PlanApprovalStatus | undefined =>
  !isActive && didAwaitApproval && resultIsError !== undefined
    ? resultIsError
      ? 'rejected'
      : 'confirmed'
    : undefined;

export const neverReachedApproval = (
  invocation: ToolInvocationEvent['toolInvocation'],
): boolean => invocation.state === 'result' && !invocation.didAwaitApproval;
